module.exports = __webpack_public_path__ + "linea-arrows-10.4e2921ae2aa6ab286dca.ttf";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-arrows-10.ttf
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-arrows-10.ttf
// module chunks = styles